import * as XLSX from 'xlsx';
import { AddProductCategoriesRequest } from '../../../../../ApiOld/Api/ApiServerVov';

export function importExcel(
    t: any,
    authorizedApi: any,
    file: File,
    refresh: () => void,
) {
    const reader = new FileReader();

    reader.onload = (e) => {
        if (e.target) {
            setTimeout(() => {
                if (e.target) {
                    const workbook = XLSX.read(e.target.result, { type: 'binary' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    let counterRow = 1;
                    const addNames: string[] = [];

                    jsonData.forEach(row => {
                        counterRow++;
                        if (row && counterRow > 2)
                            addNames.push(row[0]);
                    });

                    if (addNames.length > 0) {
                        authorizedApi.addProductCategories(new AddProductCategoriesRequest({ names: addNames })).then(() => {
                            refresh();
                        });
                    }
                }
            }, 0);
        }
    };

    reader.readAsArrayBuffer(file);
}







